"use client";

import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ListingCard, ListingCardSkeleton } from "./listing-card";
import { useFavorites } from "@/hooks";
import type { Listing } from "@/types";

interface FeaturedListingsProps {
  listings: Listing[];
}

export function FeaturedListings({ listings }: FeaturedListingsProps) {
  const { isFavorite, toggleFavorite } = useFavorites();

  return (
    <section className="px-4 py-6 md:px-6 md:py-12 lg:px-8">
      <div className="mx-auto max-w-7xl">
        {/* Başlık */}
        <h2 className="text-foreground mb-6 text-xl font-bold tracking-tight md:mb-8 md:text-2xl">
          Öne Çıkanlar
        </h2>

        <div className="grid grid-cols-2 gap-3 sm:gap-5 md:gap-6 lg:grid-cols-4">
          {listings.map((listing) => (
            <ListingCard
              key={listing.id}
              listing={listing}
              isFavorite={isFavorite(listing.id)}
              onFavoriteClick={toggleFavorite}
            />
          ))}
        </div>

        {/* Daha Fazla Butonu */}
        <div className="mt-8 flex justify-center md:mt-10">
          <Link href="/listings">
            <Button size="lg" className="bg-primary hover:bg-primary/90 gap-2">
              Daha Fazla
              <ArrowRight className="h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}

export function FeaturedListingsSkeleton() {
  return (
    <section className="px-4 py-6 md:px-6 md:py-12 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <h2 className="text-foreground mb-6 text-xl font-bold tracking-tight md:mb-8 md:text-2xl">
          Öne Çıkanlar
        </h2>

        <div className="grid grid-cols-2 gap-3 sm:gap-5 md:gap-6 lg:grid-cols-4">
          {Array.from({ length: 12 }).map((_, i) => (
            <ListingCardSkeleton key={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
